/**
 * cl-core — CL 리뉴얼 공용 순수 TS 모듈(레인 A 소유 · 2026-10-15).
 *
 * ⛔ 외부 패키지 · Node API · '@/' 별칭 import 금지. 형제 파일 상대 import 만 쓴다.
 *    Deno 에서 쓸 때는 sloppy-imports(확장자 없는 상대 경로) 또는 번들로 읽는다.
 */
export * from './josa';
export * from './names';
export * from './forbidden';
export * from './stages';
export * from './mode';
export * from './alt';
export * from './title';
export * from './answer-lead';
export * from './siblings';
export * from './lead';
export * from './config';
export * from './ad-variant';
export * from './numbers';
export * from './kst';
export * from './money';
export * from './brands';
export * from './fact-check';
